exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".shadow-box-wrapper[data-v-1983c425]{transition:.5s;border-radius:20px!important;border:1px solid var(--border)!important;background:var(--leftMenuColor);box-shadow:0 0 0 0 rgba(0,0,0,.07),2px 2px 7px 0 rgba(0,0,0,.07),10px 10px 14px 0 rgba(0,0,0,.06),22px 22px 18px 0 rgba(0,0,0,.04),39px 38px 22px 0 rgba(0,0,0,.01),60px 60px 24px 0 transparent!important;min-height:90px;min-width:350px}.shadow-box-wrapper .icon-div[data-v-1983c425]{position:relative;z-index:1}.shadow-box-wrapper .icon-div .minor-icon[data-v-1983c425]{height:14px;width:13px;position:absolute;left:13px;top:4px;z-index:10}.advice-wrapper[data-v-1983c425]{display:flex}ion-icon[data-v-1983c425]{height:24px;width:24px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1983c425","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/views/components/layouts/shadowBox.vue
// module id = 859
// module chunks = 0